export class RequestsService {
  static create() {
    return new RequestsService(global);
  }

  constructor(global) {
    this._global = global;
  }

  get(url, jwt) {
    return this._global.fetch(url, {
      method: 'GET',
      headers: this._getHeaders(jwt)
    });
  }

  _getHeaders(jwt) {
    return {
      'content-type': 'application/json',
      authorization: `Bearer ${jwt}`
    };
  }
}
